import * as actionTypes from 'modules/appointmentTask/actionTypes';
import { createReducer } from 'utils/ReduxUtils';

const initialState = false;

const isLoading = () => true;
const isEnding = () => false;

export default createReducer(initialState, {
  [actionTypes.POST_RENTAL_VEHICLE_TASK_REQUEST]: isLoading,
  [actionTypes.POST_CLIENT_DOCUMENT_REQUEST]: isLoading,
  [actionTypes.POST_BILLING_TASK_REQUEST]: isLoading,
  [actionTypes.POST_REQUEST]: isLoading,
  [actionTypes.POST_SUCCESS]: isEnding,
  [actionTypes.POST_FAILURE]: isEnding,
  [actionTypes.POST_FAILURE]: isEnding,
  [actionTypes.RESCHEDULE_REQUEST]: isLoading,
  [actionTypes.RESCHEDULE_SUCCESS]: isEnding,
  [actionTypes.RESCHEDULE_FAILURE]: isEnding,
  [actionTypes.PUT_REQUEST]: isLoading,
  [actionTypes.PUT_SUCCESS]: isEnding,
  [actionTypes.PUT_FAILURE]: isEnding,
  [actionTypes.DELETE_REQUEST]: isLoading,
  [actionTypes.DELETE_SUCCESS]: isEnding,
  [actionTypes.DELETE_FAILURE]: isEnding,
  [actionTypes.POST_REPAIR_ORDER_REQUEST]: isLoading,
  [actionTypes.DELETE_REPAIR_ORDER_REQUEST]: isLoading,
});
